import type { OptionsDocument, PresentationOption } from 'paintscout'

/**
 * Whether a presentation is a v2 "PresentationNext" document.
 *
 * The only reliable discriminator is key membership in the parallel
 * `options.presentationOptionsV2` map — `PresentationOption.version` is not usable
 * (getDefaultPresentation stamps `version: 2` on v1-shaped docs for the unrelated
 * "newLook" toggle). If a key somehow exists in both maps, we treat it as v1 so
 * existing quotes keep their current rendering.
 */
export function isPresentationNext(args: {
  options: OptionsDocument
  presentation?: Pick<PresentationOption, 'key'>
}): boolean {
  const { options, presentation } = args
  const key = presentation?.key
  if (!key) {
    return false
  }

  const inV1 = !!options?.options?.presentationOptions?.values?.[key]
  const inV2 = !!options?.options?.presentationOptionsV2?.values?.[key]

  return inV2 && !inV1
}
